var _circle, _path, _path2, _path3, _path4, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgPushAgree(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 107,
    viewBox: "0 0 200 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 100.5,
    cy: 53.5,
    r: 53.5,
    fill: "#F6F4FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m99.5 46-10.447 5.224a1 1 0 0 0-.553.894V80.5M100.5 46l10.447 5.224a1 1 0 0 1 .553.894V80.5",
    stroke: "#BE69C3",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m100.374 35.23 24.651 9.942a1 1 0 0 1 .626.928v27.846a1 1 0 0 1-.597.915l-24.651 10.868a1 1 0 0 1-.806 0L74.946 74.861a1 1 0 0 1-.597-.915V46.1a1 1 0 0 1 .626-.928l24.65-9.943a1 1 0 0 1 .749 0z",
    stroke: "#BE69C3",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m75 46 24.597 10.823a1 1 0 0 0 .806 0L125 46M100 57v29",
    stroke: "#BE69C3",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M114.884 44.108c-1.674.967-5.059 1.93-8.284 2.285-1.601.177-3.091.195-4.254.015-1.23-.19-1.803-.555-1.99-.864-.175-.288-.227-.936.218-2.094.42-1.09 1.183-2.372 2.144-3.675 1.935-2.623 4.491-5.092 6.166-6.059 3.284-1.896 7.189-.948 8.803 1.846 1.613 2.794.481 6.65-2.803 8.546zM85.168 44.108c1.674.967 5.06 1.93 8.284 2.285 1.601.177 3.091.195 4.254.015 1.23-.19 1.804-.555 1.99-.864.175-.288.228-.936-.218-2.094-.42-1.09-1.182-2.372-2.143-3.675-1.935-2.623-4.492-5.092-6.167-6.059-3.284-1.896-7.189-.948-8.802 1.846-1.613 2.794-.482 6.65 2.802 8.546z",
    fill: "#F6F4FA",
    stroke: "#BE69C3",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 129,
    cy: 37,
    r: 3,
    fill: "#F7E237"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 122,
    cy: 28,
    r: 2,
    fill: "#BE69C3"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 131.5,
    cy: 27.5,
    r: 1.5,
    fill: "#222"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 66.5,
    cy: 31.5,
    r: 1.5,
    fill: "#222"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 67,
    cy: 42,
    r: 2,
    fill: "#BE69C3"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 35,
    r: 3,
    fill: "#F7E237"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgPushAgree);
export default __webpack_public_path__ + "static/media/img_push_agree.0407af160c38ff1c90912b0386d98e4c.svg";
export { ForwardRef as ReactComponent };